module.exports = __webpack_public_path__ + "img/xiazai.7898bb6d.png";